import { PlaceholdersType } from '../../types/flowpage'
import { RootPageState } from '../../redux/types'
import { usePageSelector } from '../usePageSelector'

export function usePlaceholders(): PlaceholdersType | undefined {
  return usePageSelector((state: RootPageState) => state.fpFunnelReducer.placeholders)
}
